import PropTypes from 'prop-types';
import React from 'react';
import { RatingStyles } from '../constants/feedback-constants';
import EmojiRating from './emoji/emoji-rating';
import NpsRating from './nps/nps-rating';
import StarRating from './stars/star-rating';
import ThumbsRating from './thumbs/thumbs-rating';

const RATING_COMPONENTS = {
  [RatingStyles.STARS]: StarRating,
  [RatingStyles.NPS]: NpsRating,
  [RatingStyles.THUMBS]: ThumbsRating,
  [RatingStyles.EMOJI]: EmojiRating,
};

const RatingInput = ({ ratingStyle, value, onChange }) => {
  const Component = RATING_COMPONENTS[ratingStyle] || StarRating;
  return <Component value={value} onChange={onChange} />;
};

RatingInput.propTypes = {
  ratingStyle: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

RatingInput.defaultProps = {
  ratingStyle: RatingStyles.STARS,
  value: null,
};

export default RatingInput;
